import React, { useMemo } from 'react';
import { LayoutSingleColumn, NamedLink, ExternalLink } from '../../components';
import { injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { help } from './help';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import StaticPage from '../PageBuilder/StaticPage';

import css from './HelpCenterPage.module.css';
import { useConfiguration } from '../../context/configurationContext';

const HelpCenterSectionComponent = props => {
  const { titleKey, subsections, isHorizontal, showBackToCrion, intl, config } = props;

  return (
    <section className={css.section}>
      <span className={css.title}>{intl.formatMessage({ id: `HelpCenter.${titleKey}` })}</span>
      <div className={classNames(css.subsections, { [css.subsectionsHorizontal]: isHorizontal })}>
        {subsections.map(subsection => {
          const { icon: Icon, iconProps, subtitleKey, links } = subsection;
          const subtitle = intl.formatMessage({ id: `HelpCenter.${subtitleKey}` });

          return (
            <div key={subtitleKey} className={css.subsection}>
              <div className={css.iconWrapper}>
                <Icon {...iconProps} />
              </div>
              <div className={css.subtitle}>{subtitle}</div>
              <div className={css.links}>
                {links.map(link => {
                  const { parentTextKey = 'HelpCenter', textKey, params, href } = link;

                  const text = intl.formatMessage({ id: `${parentTextKey}.${textKey}` });

                  return href ? (
                    <ExternalLink key={textKey} href={href}>
                      {text}
                    </ExternalLink>
                  ) : (
                    <NamedLink key={textKey} name="HelpCenterPage" params={params}>
                      {text}
                    </NamedLink>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      {showBackToCrion && (
        <NamedLink name="LandingPage" className={css.primaryButton}>
          <FormattedMessage
            id="HelpCenter.backToCrion"
            values={{ marketplaceName: config.marketplaceName }}
          />
        </NamedLink>
      )}
    </section>
  );
};

const HelpCenterSection = injectIntl(HelpCenterSectionComponent);

const horizontalHelp = help.filter(h => h.isHorizontal);
const verticalHelp = help.filter(h => !h.isHorizontal);

const HelpCenterBasePage = props => {
  const { intl } = props;

  const config = useConfiguration();

  const messages = useMemo(
    () => ({
      title: intl.formatMessage({ id: 'General.help' }),
    }),
    [intl]
  );

  return (
    <StaticPage
      title={messages.title}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HelpCenterBasePage',
        name: messages.title,
      }}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer currentPage="HelpCenterBasePage" />}
        footer={<FooterContainer />}
        mainColumnClassName={css.staticPageWrapper}
      >
        {horizontalHelp.map(h => (
          <HelpCenterSection key={h.titleKey} {...h} config={config} />
        ))}
        <div className={css.sideBySideSections}>
          {verticalHelp.map((h, i) => (
            <HelpCenterSection
              key={h.titleKey}
              {...h}
              showBackToCrion={i === verticalHelp.length - 1}
              config={config}
            />
          ))}
        </div>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default injectIntl(HelpCenterBasePage);
